// extracted by mini-css-extract-plugin
module.exports = {"title":"index-module__title___ehouU","body":"index-module__body___fjTzI"};